import { observer } from 'mobx-react-lite'
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid'
import { useInjection } from '@core/providers/inversify-react.provider'
import { BreadcrumbsPresenter } from './breadcrumbs.presenter'

export const BreadcrumbsComponent = observer(() => {
  const presenter: BreadcrumbsPresenter = useInjection(BreadcrumbsPresenter)
  const vm = presenter.viewModel

  if (!vm.showBreadcrumbs) {
    return null
  }

  return (
    <nav aria-label={vm.navLabel} className="flex">
      <ol role="list" className="flex flex-wrap items-center gap-x-1 gap-y-1">
        {vm.breadcrumbs.map((crumb) => (
          <li key={crumb.id} className="flex items-center">
            {crumb.showSeparator && (
              <ChevronRightIcon aria-hidden="true" className="size-4 shrink-0 text-shell-ink-muted mr-1" />
            )}
            {crumb.isCurrent ? (
              <span aria-current="page" className="text-sm font-semibold text-shell-ink">
                {crumb.showHomeIcon ? <HomeIcon aria-hidden="true" className="size-4" /> : crumb.visibleName}
              </span>
            ) : (
              <button
                type="button"
                onClick={() => presenter.navigate(crumb)}
                className="rounded-md text-sm font-medium text-shell-ink-muted hover:text-shell-ink-secondary"
              >
                {crumb.showHomeIcon ? <HomeIcon aria-hidden="true" className="size-4" /> : crumb.visibleName}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
})
